/* GRO — "What people are looking for" (sections/gro-home-searches.liquid).
   1. When the list scrolls into view, the rules under each row draw in left to right (CSS does the
      motion; this only adds .is-armed / .is-in). Without JS or with reduced motion they are simply there.
   2. Opening a row fetches three in-stock products for that search from the store's own predictive
      search, so the peek always matches what See all will show. One row open at a time. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function arm(list) {
    if (reduce || !('IntersectionObserver' in window)) return;
    list.classList.add('is-armed');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          list.classList.add('is-in');
          io.disconnect();
        }
      });
    }, { threshold: 0.25 });
    io.observe(list);
  }

  function skeleton(ul) {
    ul.textContent = '';
    for (var i = 0; i < 3; i++) {
      var li = document.createElement('li');
      li.className = 'is-loading';
      li.appendChild(document.createElement('span'));
      ul.appendChild(li);
    }
  }

  function fill(peek) {
    if (peek.getAttribute('data-loaded')) return;
    peek.setAttribute('data-loaded', '1');
    var ul = peek.querySelector('[data-gro-hs-products]');
    skeleton(ul);
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(peek.getAttribute('data-q')) +
      '&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=hide';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
        ul.textContent = '';
        ps.slice(0, 3).forEach(function (p) {
          var src = (p.featured_image && p.featured_image.url) || p.image;
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = p.url;
          a.setAttribute('aria-label', p.title);
          if (src) {
            var img = document.createElement('img');
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=360';
            img.alt = '';
            img.width = 360;
            img.height = 450;
            a.appendChild(img);
          }
          li.appendChild(a);
          ul.appendChild(li);
        });
      })
      .catch(function () {
        ul.textContent = '';
        peek.removeAttribute('data-loaded');
      });
  }

  document.addEventListener('toggle', function (ev) {
    var d = ev.target;
    if (!d || !d.classList || !d.classList.contains('gro-hs__details') || !d.open) return;
    var host = d.closest('[data-gro-hs]');
    if (host) {
      host.querySelectorAll('.gro-hs__details[open]').forEach(function (other) {
        if (other !== d) other.open = false;
      });
    }
    fill(d.querySelector('[data-gro-hs-peek]'));
  }, true);

  document.querySelectorAll('[data-gro-hs] .gro-hs__cols').forEach(arm);
})();
